import {
  GET_TEST_DEFINITIONS,
  GET_TEST_DEFINITIONS_SUCCESS,
  ADD_NEW_TEST_DEFINITION,
  ADD_TEST_DEFINITION_SUCCESS,
  UPDATE_TEST_DEFINITION,
  UPDATE_TEST_DEFINITION_SUCCESS,
  DELETE_TEST_DEFINITION,
  DELETE_TEST_DEFINITION_SUCCESS,
  TEST_DEFINITION_API_ERROR

} from "./actionTypes"

export const getTestDefinitions = () => ({
  type: GET_TEST_DEFINITIONS,
})

export const getTestDefinitionsSuccess = testDefinition => ({
  type: GET_TEST_DEFINITIONS_SUCCESS,
  payload: testDefinition,
})

export const addNewTestDefinition = testDefinition => ({
  type: ADD_NEW_TEST_DEFINITION,
  payload: testDefinition,
})

export const addTestDefinitionSuccess = testDefinition => ({
  type: ADD_TEST_DEFINITION_SUCCESS,
  payload: testDefinition,
})

export const updateTestDefinition = testDefinition => ({
  type: UPDATE_TEST_DEFINITION,
  payload: testDefinition,
})

export const updateTestDefinitionSuccess = testDefinition => ({
  type: UPDATE_TEST_DEFINITION_SUCCESS,
  payload: testDefinition,
})

export const deleteTestDefinition = testDefinition => ({
  type: DELETE_TEST_DEFINITION,
  payload: testDefinition,
})

export const deleteTestDefinitionSuccess = testDefinition => ({
  type: DELETE_TEST_DEFINITION_SUCCESS,
  payload: testDefinition,
})

export const testDefinitionsApiError = error => ({
  type: TEST_DEFINITION_API_ERROR,
  payload: error,
})